// Ошибка API поверх huma problem+json. Несёт HTTP-статус, стабильный доменный
// code (PROJECT_NOT_FOUND, SLUG_TAKEN, VERSION_CONFLICT, FORBIDDEN, …) и detail —
// по ним UI разводит 403-экран, конфликт версий, тосты.

interface ProblemBody {
  status?: number
  title?: string
  detail?: string
  code?: string
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string | undefined
  readonly detail: string | undefined

  constructor(status: number, message: string, code?: string, detail?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.detail = detail
  }

  static from(response: Response, body: unknown): ApiError {
    const problem = (body ?? {}) as ProblemBody
    const message = problem.detail || problem.title || `HTTP ${response.status}`
    return new ApiError(response.status, message, problem.code, problem.detail)
  }

  get isUnauthorized(): boolean {
    return this.status === 401
  }

  get isForbidden(): boolean {
    return this.status === 403
  }

  get isConflict(): boolean {
    return this.status === 409
  }
}

// Внятный текст для ошибок write-through записи в хаб (company/project CRUD +
// visibility проксируются в хаб): 503 — хаб недоступен, 409 — конфликт версий.
// Возвращает null, если ошибка не про write-through — вызывающий даёт свой fallback.
export function writeThroughErrorText(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null
  if (error.status === 503 || error.code === 'HUB_UNAVAILABLE') {
    return 'Хаб временно недоступен — попробуйте позже'
  }
  if (error.status === 409 || error.code === 'CONFLICT' || error.code === 'VERSION_CONFLICT') {
    return 'Данные изменились в другом месте — обновите страницу'
  }
  return null
}
